import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { LocationDTO } from '../../../model/LocationDTO';

export interface Link {
	rel: string,
	href: string,
	sizes: string,
	type: string
}

@Block() @Component
export class PageMetaLocationBlock extends BaseBlock {
	@Prop() location: LocationDTO;

	mounted() {
		const iconsDefault: string = `
		rel: "icon", sizes: "16x16", type: "image/png", href: "/wms3/favicon-16x16.png";
		rel: "icon", sizes: "32x32", type: "image/png", href: "/wms3/favicon-32x32.png";
		rel: "icon", sizes: "192x192", type: "image/png", href: "/wms3/android-chrome-192x192.png";
		rel: "icon", sizes: "512x512", type: "image/png", href: "/wms3/android-chrome-512x512.png";
		rel: "apple-touch-icon", sizes: "180x180", type: "image/png", href: "/wms3/apple-touch-icon-180x180.png";
		rel: "icon", href: "/wms3/favicon.ico"
		`;

		const mainScript = this.getText('page-main-script');
		const scripts = this.getText('page-scripts').split(';');
		const icons = (this.getText('page-icons') || iconsDefault).split(';').map(i => i.trim());

		this.removeExistingIcons();

		Promise.all([scripts.map(i => this.loadScript(i)), this.parseIcon(icons).map(i => this.loadIcon(i))]).then(() => {
			if (mainScript && mainScript.trim()) {
				// smazani dynamickeho scriptu
				document.head
					.querySelectorAll('script[data-dynamic-main]')
					.forEach(el => el.remove());

				const script = document.createElement('script');
				script.src = mainScript;
				script.dataset.dynamicMain = 'true';   
				document.head.appendChild(script);
			}
		})
	}

	loadIcon(linkString: any) {
		return new Promise((resolve, reject) => {
			const l = linkString as Link;
			const link = document.createElement('link');
			link.rel = l.rel;
			link.href = l.href;
			link.setAttribute('data-dynamic-favicon', 'true');

			if (l.sizes) {
				link.setAttribute('sizes', l.sizes);
			}

			if (l.type) {
				link.type = l.type
			}

			document.head.appendChild(link);
		}).then(() => console.log("link loaded"));
	}

	parseIcon(icons: string[]) {
		return icons.map(i => {
			const obj: any = {};
			const regex = /(\w+):\s*"(.*?)"/g;
			let match;

			while ((match = regex.exec(i)) !== null) {
				const [, key, value] = match;
				obj[key] = value;
			}

			return obj as Link;
		});
	}

	removeExistingIcons() {
		document.head
			.querySelectorAll('link[data-dynamic-favicon]')
			.forEach(el => el.remove());
	}

	loadScript(src: string) {
		if (!src || !src.trim()) {
			return Promise.resolve(null);
		}

		const cleanSrc = src.replace(/[\n\r]/g, '').trim();

		// uz nacteny nepridavej znovu
		const existing = document.querySelector(`script[src="${cleanSrc}"]`);
		if (existing) {
			return Promise.resolve(existing);
		}

		return new Promise((resolve) => {
			const script = document.createElement('script');
			script.src = cleanSrc;
			script.dataset.dynamicScript = 'true';

			script.onload = () => resolve(script);
			script.onerror = () => {
				console.log(`Script load error for ${src}`);
				resolve(null);
			};

			document.head.appendChild(script);
		}).then(() => console.log("Script loaded"));
	}

	get cityName(): string {
		var result = this.location.city;
		if (this.location.cityPart) {
			result += " - " + this.location.cityPart;
		}

		return result;
	}

	get titleText(): string {
		return this.getText('page-title', [
			this.cityName,
			this.location.name
		]);
	}

	get descriptionText(): string {
		return this.getText('page-description', [
			this.cityName,
			this.location.name
		]);
	}
}

export default PageMetaLocationBlock;
